import { FormRichTextField } from '../../components';
import { TEXT_AREA_MAX_LENGTH } from '../../constants';

import type { ChildBehaviorIssuesFieldProps } from './types';

export default function ChildBehaviorIssuesField({
  formik,
  disabled,
  onBlur,
}: ChildBehaviorIssuesFieldProps) {
  return (
    <FormRichTextField
      disabled={disabled}
      formik={formik}
      label="Any other child behavior issues"
      maxLength={TEXT_AREA_MAX_LENGTH}
      name="child_behavior_issues"
      onBlur={onBlur}
      placeholder="Describe other behavior issues"
    />
  );
}
